var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChilledPumpIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.032 5.31299V1.90723H39.5974V5.31299H43.0032V19.0496H39.5974V15.6438H29.3801V25.8611H25.9744V19.0496H1.90698V42.8899H25.9744V36.0784H29.3801V46.2957H39.5974V42.8899H43.0032V56.6265H39.5974V60.0322H60.032V56.6265H56.6262V42.8899H60.032V19.0496H56.6262V5.31299H60.032ZM15.7571 32.6726H5.31274V29.2668H15.7571V32.6726ZM15.7571 22.4553V25.8611H5.31274V22.4553H15.7571ZM5.31274 36.0784H15.7571V39.4841H5.31274V36.0784ZM22.5686 39.4841H19.1628V22.4553H22.5686V39.4841ZM25.9744 32.6726V29.2668H29.3801V32.6726H25.9744ZM36.1916 42.8899H32.7859V19.0496H36.1916V42.8899ZM46.4089 56.6265V53.1072H53.2205V56.6265H46.4089ZM53.2205 49.7014H46.4089V42.8899H53.2205V49.7014ZM56.6262 39.4841H39.5974V22.4553H56.6262V39.4841ZM46.4089 19.0496V12.238H53.2205V19.0496H46.4089ZM53.2205 8.83228H46.4089V5.31299H53.2205V8.83228Z",
    fill: "#25A18E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8149 32.6726H53.2207V36.0784H49.8149V32.6726Z",
    fill: "#25A18E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8149 25.8611H53.2207V29.2668H49.8149V25.8611Z",
    fill: "#25A18E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChilledPumpIcon);
export default __webpack_public_path__ + "static/media/ChilledPumpIcon.5d209b68fa3cedd5261798e79c5d94ae.svg";
export { ForwardRef as ReactComponent };